import { render, staticRenderFns } from "./IntegratedSearch.vue?vue&type=template&id=6f778085&scoped=true&"
import script from "./IntegratedSearch.vue?vue&type=script&lang=js&"
export * from "./IntegratedSearch.vue?vue&type=script&lang=js&"
import style0 from "./IntegratedSearch.vue?vue&type=style&index=0&id=6f778085&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f778085",
  null
  
)

component.options.__file = "IntegratedSearch.vue"
export default component.exports